import React from "react";

const HAFHDirectorPolicy = {
  ROLE_HIERARCHY: {
    ADMIN: 6,
    DIRECTOR: 5,
    COORDINATOR: 4,
    OWNER: 3,
    MANAGER: 2,
    STUDENT: 1,
    PARENT: 0,
    HUMA: 1.5,
  },

  APPROVAL_RULES: {
    COORDINATOR: ["DIRECTOR", "ADMIN"],
    TRUSTEE: ["ADMIN"],
    INSTITUTION: ["ADMIN"],
    OWNER: ["ADMIN"],
    MANAGER: ["OWNER", "ADMIN"],
    STUDENT: ["MANAGER", "COORDINATOR", "DIRECTOR", "ADMIN"],
    HUMA: ["ADMIN", "DIRECTOR", "COORDINATOR", "OWNER", "MANAGER"],
  },

  ONBOARDING_STATES: {
    INITIATED: "INITIATED",
    VALIDATION_PENDING: "VALIDATION_PENDING",
    APPROVAL_PENDING: "APPROVAL_PENDING",
    IN_PROGRESS_APPROVAL: "IN_PROGRESS_APPROVAL",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    EXPIRED: "EXPIRED",
  },

  REQUEST_TYPES: {
    ROLE: "ROLE",
    HOSTEL_JOIN: "HOSTEL_JOIN",
    HOSTEL_CREATE: "HOSTEL_CREATE",
    BULK_UPLOAD: "BULK_UPLOAD",
  },

  INITIATED_BY: {
    USER: "USER",
    DIRECTOR: "DIRECTOR",
    ADMIN: "ADMIN",
    OWNER: "OWNER",
  },

  APPROVAL_ENGINE: {
    COORDINATOR: ["DIRECTOR", "ADMIN"],
    OWNER: ["ADMIN"],
    TRUSTEE: ["ADMIN"],
    INSTITUTION: ["ADMIN"],
    MANAGER: ["OWNER", "ADMIN"],
    STUDENT: ["MANAGER", "COORDINATOR", "DIRECTOR", "ADMIN"],
  },

  SYSTEM_RULES: {
    USER_MUST_EXIST_BEFORE_ROLE_ASSIGNMENT: true,
    ROLE_ACTIVATION_REQUIRES_APPROVAL: true,
    ADMIN_CAN_OVERRIDE_ALL_FLOWS: true,
    HOSTEL_CODE_IS_PRIMARY_KEY: true,
    SINGLE_ACTIVE_HOSTEL_RULE: {
      APPLIES_TO: ["STUDENT", "MANAGER"],
      MAX_ACTIVE: 1,
    },
    HIERARCHY_FLOW: [
      "ADMIN",
      "DIRECTOR",
      "COORDINATOR",
      "OWNER",
      "MANAGER",
      "STUDENT",
      "PARENT",
    ],
  },

  STATE_FLOW: {
    INITIATED: "VALIDATION_PENDING",
    VALIDATION_PENDING: "APPROVAL_PENDING",
    APPROVAL_PENDING: "IN_PROGRESS_APPROVAL",
    IN_PROGRESS_APPROVAL: "APPROVED",
    APPROVED: "ACTIVE",
    REJECTED: null,
    ACTIVE: null,
  },

  ACTIVE_EFFECTS: {
    ROLE_ASSIGNED: true,
    HOSTEL_ASSOCIATION_CREATED: true,
    PREVIOUS_HOSTEL_DEACTIVATED_FOR_SINGLE_RULE: true,
    AUDIT_LOG_CREATED: true,
  },
};

const Section = ({ title, children }) => (
  <div className="bg-slate-900 p-4 rounded-xl mb-4">
    <h2 className="text-green-400 font-bold mb-2 text-sm lg:text-lg">
      {title}
    </h2>
    <div className="text-xs lg:text-sm text-slate-200">{children}</div>
  </div>
);

const HAFHDirectorPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-white [&_p]:text-gray-100 p-4">

      <h1 className="text-lg lg:text-2xl font-bold text-center mb-4">
        🏠 HAFH Director Policy Dashboard
      </h1>

      {/* ROLE HIERARCHY */}
      <Section title="Role Hierarchy">
        {Object.entries(HAFHDirectorPolicy.ROLE_HIERARCHY).map(([k, v]) => (
          <p key={k}>
            {k}: <span className="text-green-400">{v}</span>
          </p>
        ))}
      </Section>

      {/* APPROVAL RULES */}
      <Section title="Approval Rules">
        {Object.entries(HAFHDirectorPolicy.APPROVAL_RULES).map(([k, v]) => (
          <p key={k}>
            {k}: {v.join(", ")}
          </p>
        ))}
      </Section>

      {/* ONBOARDING STATES */}
      <Section title="Onboarding States">
        {Object.entries(HAFHDirectorPolicy.ONBOARDING_STATES).map(
          ([k, v]) => (
            <p key={k}>
              {k} → <span className="text-yellow-300">{v}</span>
            </p>
          )
        )}
      </Section>

      {/* REQUEST TYPES */}
      <Section title="Request Types">
        {Object.entries(HAFHDirectorPolicy.REQUEST_TYPES).map(([k, v]) => (
          <p key={k}>{k}: {v}</p>
        ))}
      </Section>

      {/* INITIATED BY */}
      <Section title="Initiated By">
        {Object.entries(HAFHDirectorPolicy.INITIATED_BY).map(([k, v]) => (
          <p key={k}>{k}: {v}</p>
        ))}
      </Section>

      {/* SYSTEM RULES */}
      <Section title="System Rules">
        {Object.entries(HAFHDirectorPolicy.SYSTEM_RULES).map(([k, v]) => (
          <div key={k} className="mb-2">
            <p className="text-green-300 font-semibold">{k}</p>
            <pre className="text-xs bg-slate-800 p-2 rounded overflow-auto">
              {JSON.stringify(v, null, 2)}
            </pre>
          </div>
        ))}
      </Section>

      {/* STATE FLOW */}
      <Section title="State Flow Machine">
        {Object.entries(HAFHDirectorPolicy.STATE_FLOW).map(([k, v]) => (
          <p key={k}>
            {k} → <span className="text-blue-300">{v || "END"}</span>
          </p>
        ))}
      </Section>

      {/* ACTIVE EFFECTS */}
      <Section title="Active Effects">
        {Object.entries(HAFHDirectorPolicy.ACTIVE_EFFECTS).map(([k, v]) => (
          <p key={k}>
            {k}:{" "}
            <span className="text-green-400">
              {v.toString()}
            </span>
          </p>
        ))}
      </Section>

    </div>
  );
};

export default HAFHDirectorPolicyPage;